import { buildQuery } from '../lib/helper';
import client from '../lib/http-client';

const endpoint = '/api/votings';

export default {
	/*
		Get list voting
	*/
	getList(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}?${query}`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Get active voting
	*/
	getActive(eventSlug, cb, errorCb) {
		const url = `${endpoint}/${eventSlug}`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Start voting
	*/
	startVoting(votingId, cb, errorCb) {
		const url = `${endpoint}/${votingId}/start`;
		client.post(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Stop Voting
	*/
	stopVoting(eventSlug, cb, errorCb) {
		const url = `${endpoint}/${eventSlug}/stop`;
		client.post(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Get details
	*/
	getDetails(id, cb, errorCb) {
		const url = `${endpoint}/${id}/show`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Create
	*/
	create(params, cb, errorCb) {
		const url = endpoint;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Update
	*/
	update(id, params, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Bulk delete
	*/
	bulkDelete(ids, cb, errorCb) {
		const params = {
			voting_ids: JSON.stringify(ids),
			is_deleted: 1,
		};
		const url = `${endpoint}`;
		const responseHandler = (response) => {
			if (cb) {
				cb(response.data);
			}
		};
		const errorHandler = (e) => {
			if (errorCb) {
				errorCb(e);
			}
		};
		client.delete(url, { data: params })
			.then(responseHandler)
			.catch(errorHandler);
	},

	// Create Voting Option
	createOption(votingId, params, cb, errorCb) {
		const url = `${endpoint}/${votingId}/options`;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},


	// Update Voting Option
	updateOption(votingid, optionId, params, cb, errorCb) {
		const url = `${endpoint}/${votingid}/options/${optionId}`;
		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	// Bulk Delete
	bulkDeleteOption(votingId, ids, cb, errorCb) {
		const params = {
			voting_option_ids: JSON.stringify(ids),
			is_deleted: 1,
		};
		const url = `${endpoint}/${votingId}/options`;
		const responseHandler = (response) => {
			if (cb) {
				cb(response.data);
			}
		};
		const errorHandler = (e) => {
			if (errorCb) {
				errorCb(e);
			}
		};
		client.delete(url, { data: params })
			.then(responseHandler)
			.catch(errorHandler);
	},

	/*
		Vote
	*/
	vote(params, cb, errorCb) {
		const url = `${endpoint}/vote`;

		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Next round
	*/
	nextRound(voteId, cb, errorCb) {
		const url = `${endpoint}/${voteId}/nextRound`;

		client.put(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Set display number in voting
	*/
	setDisplayNumber(params, cb, errorCb) {
		const url = `${endpoint}/display_number/set`;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Clear display number
	*/
	clearDisplayNumber(params, cb, errorCb) {
		const url = `${endpoint}/display_number/clear`;
		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Get list voting on display
	*/
	getVotingsOnDisplay(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/display_number/get?${query}`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Send votings to screen
	*/
	sendToScreen(params, cb, errorCb) {
		const url = `${endpoint}/send_to_screen`;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
	 * Get archive
	*/
	getArchive(id, cb, errorCb) {
		const url = `${endpoint}/${id}/archived`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
	 * Duplicate
	*/
	duplicate(id, cb, errorCb) {
		const url = `${endpoint}/${id}/duplicate`;
		client.post(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
	 * Reorder
	 */
	reorder(params, cb, errorCb) {
		const url = `${endpoint}/reorder`;

		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
	 * Options reorder
	 */
	optionsReorder(votingId, params, cb, errorCb) {
		const url = `${endpoint}/${votingId}/options/reorder`;

		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},
};
